<template>
  <div class="width-percent-100">
    <b-row
      class="margin-0 width-percent-100 flex-start-between mobile-flex-direction-column-reverse tablet-flex-direction-column-reverse"
    >
      <b-col cols="" class="padding-0">
        <b-row class="margin-0">
          <b-col
            cols="12"
            lg=""
            class="padding-0 mobile-margin-bottom-8 tablet-margin-bottom-8"
          >
            <AvatarGroup
              :data="generatePersonData"
              :singleAvatarSize="48"
              :singleAvatarCaptionMargin="18"
              :defaultImagePadding="10"
              :hasType="false"
              :hasProfilePopup="false"
            />
          </b-col>
          <b-col
            cols="12"
            lg=""
            class="padding-0 color-complementary-300 font-size-12"
          >
            <div class="flex-start">
              {{ $lang.centerExecute }}:
              <div class="margin-right-4">
                {{ generateItem.centerExecuteCaption }}
                <span class="color-complementary-100"> | </span>
                <span>
                  {{ generateItem.centerExecuteId }}
                </span>
              </div>
            </div>
            <div>
              <span class="margin-left-16">
                {{ $lang.startDate }}: {{ generateItem.startDate }}
              </span>
            </div>
            <div>
              <span class="margin-left-16">
                {{ $lang.created_by }}: {{ generateItem.createdBy }}
              </span>
              <span>
                {{ $lang.created_at }}:
                <span v-html="generateItem.createdAt" />
              </span>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        cols="12"
        lg="auto"
        class="padding-0 flex-end mobile-flex-justify-content-between tablet-flex-justify-content-between margin-bottom-8"
      >
        <StatusBox :item="generateItem" :justView="true" />
        <MenuPopupWrapper
          iconClass="margin-right-8 color-complementary-200 cursor--pointer"
          menuClass="left-0 top-10 z-index-1 padding-top-24"
          :items="itemButtons"
          :permissions="permissions"
          :showMenu="isMenuPopup"
          :rowItem="item"
          @click="handleOpenItemMenu"
          @close="handleCloseItemMenu"
        />
      </b-col>
    </b-row>

    <Modal
      :show="isRemoveModal"
      :title="$lang.removeCenterExecuteAccess"
      :closeOnBackdrop="false"
      :hasClose="true"
      :hasFooter="true"
      size="sm"
      :okButton="true"
      okButtonVariant="filled-error"
      :okButtonText="$lang.remove"
      :ok="handleRemove"
      @close="handleCloseRemoveModal"
    >
      <template #body>
        <div class="margin-bottom-24 font-size-14 color-complementary-300">
          {{ $lang.removeSureMessage }}
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { MenuPopupWrapper, Modal, AvatarGroup } from "@/components/re-design";
import StatusBox from "../../center-execute/components/StatusBox.vue";
import { pathOr } from "ramda";
import { computed, ref, toRefs } from "vue";
import {
  createDateFormat,
  generateError,
  generateLang,
  toastAlert,
} from "@/shared/utils";
import { deleteCenterExecuteAccess } from "@/modules/kanoon/services";
export default {
  components: { MenuPopupWrapper, Modal, AvatarGroup, StatusBox },
  props: {
    item: {
      type: Object,
      default: null,
    },
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    // bind props
    const { item } = toRefs(props);

    const handleReloadList = () => emit("handleReloadList");

    // generate item
    const generateItem = computed(() => {
      const parvandeh = pathOr(null, ["parvandeh"], item.value);
      const person = pathOr(null, ["person"], item.value);
      const centerExecute = pathOr(null, ["center_execute"], item.value);
      const name = pathOr("", ["name"], person);
      const family = pathOr("", ["family"], person);
      return {
        personName: `${name} ${family}`,
        parvandehNumber: pathOr("", ["parvandeh_number"], parvandeh),
        parvandehCode: pathOr(null, ["code"], parvandeh),
        termCaption: pathOr("", ["term_caption"], parvandeh),
        personCode: pathOr(null, ["code"], person),
        image: pathOr("", ["image_address"], person),
        centerExecuteId: pathOr(null, ["id"], centerExecute),
        centerExecuteCaption: pathOr("", ["caption"], centerExecute),
        createdBy: pathOr("", ["created_by"], item.value),
        createdAt: createDateFormat(
          pathOr("", ["created_at", "jalali"], item.value)
        ),
        status: pathOr(null, ["status", "id"], centerExecute),
        startDate: pathOr("", ["start_date", "jalali"], centerExecute),
      };
    });

    const generatePersonData = computed(() => {
      return {
        id: generateItem.value.parvandehNumber,
        personCode: generateItem.value.personCode,
        name: generateItem.value.personName,
        images: [generateItem.value.image],
        secondCaption: generateItem.value.termCaption,
      };
    });

    const isMenuPopup = ref(false);
    const handleOpenItemMenu = () => (isMenuPopup.value = true);
    const handleCloseItemMenu = () => (isMenuPopup.value = false);

    // handle remove action
    const isRemoveModal = ref(false);
    const handleOpenRemoveModal = () => (isRemoveModal.value = true);
    const handleCloseRemoveModal = (shouldReloadList = false) => {
      isRemoveModal.value = false;
      if (shouldReloadList) {
        setTimeout(() => handleReloadList(), 300);
      }
    };
    const handleRemove = async () => {
      try {
        const parvandehCode = pathOr(null, ["parvandeh", "code"], item.value);
        const centerExecuteCode = pathOr(
          null,
          ["center_execute", "code"],
          item.value
        );
        const response = await deleteCenterExecuteAccess(
          parvandehCode,
          centerExecuteCode
        );
        const { message } = response;
        toastAlert(message);
        handleCloseRemoveModal(true);
      } catch (error) {
        generateError(error);
      }
    };

    const itemButtons = computed(() => [
      {
        caption: generateLang(["remove"]),
        icon: "trash-can-outline",
        show: true,
        permissions: ["admin"],
        allowStatus: [1],
        allowUserExecutiveRoles: [3, null],
        loading: false,
        click: handleOpenRemoveModal,
      },
    ]);

    // return data to be used in template
    return {
      isMenuPopup,
      handleOpenItemMenu,
      handleCloseItemMenu,
      itemButtons,
      isRemoveModal,
      handleCloseRemoveModal,
      handleRemove,
      generatePersonData,
      generateItem,
    };
  },
};
</script>
